import { BaseEditViewStore} from 'core/stores';
import { action } from "mobx";
import { FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm } from '../../facility-order-new-flow-us-intake/forms';
import { NikoPatientTemplateService } from '../services';

class PatientTemplateClinicalStatusNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const patientTemplate = componentProps.modalParams.data.patientTemplate;

        super(rootStore, {
            name: 'patient-template-clinical-status-note-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm,
            id: patientTemplate.id,
            actions: () => {
                return {
                    get: async() =>{
                        return patientTemplate;
                    },
                    update: async() =>{
                        await this.nikoPatientTemplateService.updateClinicalStatusNote({id: this.id, note: this.form.$("clinicalStatusNote").value});
                    }
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.nikoPatientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);

        this.patientTemplate = patientTemplate;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            this.actions.update();
            this.patientTemplate.clinicalStatusNote = resource.clinicalStatusNote;
            await this.modalParams.close();
            this.notifySuccessUpdate("Clinical Status Note");
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.TEMPLATE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default PatientTemplateClinicalStatusNoteModalStore;
